import { defaultFetch, defaultFetchDownload, defaultFetchImport } from "./baseApi";
import { ProjectType } from "./projectApi";

export const getProjectsTemplate = () => {
    return defaultFetchDownload("/v0/projects-import");
}

export const massImportProjects = (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append('fileType', 'xlsx');

    return defaultFetchImport("/v0/projects-import", formData);
};

export const createProject = (project: Partial<ProjectType>) => {
    return defaultFetch<ProjectType>("/v0/projects",
        {
            method: "POST",
            body: JSON.stringify(project),
        }
    );
};
